import request from '~/utils/http';

// 订单结算
export function getOrderBalance(data) {
  return request({
    url: 'api/AgentOrder/SettlementSearch',
    method: 'post',
    data: data
  })
}

// 付款申请
export function getPaymentApply(data) {
  return request({
    url: 'api/PaymentOrder/GetList',
    method: 'post',
    data: data
  })
}
// 付款申请详情
export function getPaymentApplyDetail(sendData) {
  return request({
    url: 'api/PaymentOrder/Get',
    method: 'post',
    data: sendData
  })
}

// 付汇单
export function getRemittance(data) {
  return request({
    url: 'api/PaymentInvoice/GetList',
    method: 'post',
    data: data
  })
}
// 付汇单详情
export function getRemittanceDetail(sendData) {
  return request({
    url: 'api/PaymentInvoice/Get',
    method: 'post',
    data: sendData
  })
}

// 付款单
export function getPaymentOrder(data) {
  return request({
    url: 'api/PaymentOrder/GetReceiptList',
    method: 'post',
    data: data
  })
}

// 合同
export function getOrderContract(data) {
  return request({
    url: 'api/TradeContract/GetList',
    method: 'post',
    data: data
  })
}

// 合同详情
export function getOrderContractDetail(sendData) {
  return request({
    url: 'api/TradeContract/Get',
    method: 'post',
    data: sendData
  })
}



